<h1 mat-dialog-title>{{data.action}} failure reason?</h1>
<mat-dialog-content>
  <p class="secondary-text sub-title">
    You are {{actionGerund | lowercase}} failure reason:
  </p>
  <div class="content">
    <div fxLayout="row wrap" fxFlex="100">

      <div *ngIf="data.form.controls.code && !data.form.controls.code.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.code || 'Null'}}</div>
        <div class="mat-caption"> Code </div>
      </div>

      <div *ngIf="data.form.controls.externalCode && !data.form.controls.externalCode.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.externalCode || 'Null'}}</div>
        <div class="mat-caption"> External code </div>
      </div>

      <div *ngIf="data.form.controls.name && !data.form.controls.name.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.name || 'Null'}}</div>
        <div class="mat-caption"> Name </div>
      </div>

      <div *ngIf="data.form.controls.description && !data.form.controls.description.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.description || 'Null'}}</div>
        <div class="mat-caption"> Description </div>
      </div>
      
      <div *ngIf="data.form.controls.usage && !data.form.controls.usage.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div *ngFor="let usage of usages">{{usage}}</div>
        <div class="mat-caption"> Usage </div>
      </div>

      <div *ngIf="data.form.controls.allowToSpecifyCompetitors && !data.form.controls.allowToSpecifyCompetitors.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.allowToSpecifyCompetitors ? 'True' : 'False'}}</div>
        <div class="mat-caption"> Allow to specify competitors </div>
      </div>

      <div *ngIf="data.form.controls.active && !data.form.controls.active.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.active ? 'True' : 'False'}}</div>
        <div class="mat-caption"> Active </div>
      </div>

    </div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="flex row end-center">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button [mat-dialog-close]="true" color="primary">Ok</button>
</div>